export const FETCH_SPA_SALES = "FETCH_SPA_SALES";
